import React from "react";

export default function Dashboard() {
  return (
    <div className="wip">
      <p>You'll see all the analytics about marketplace here</p>
    </div>
  );
}
